import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RealmService} from '../Services/Realm/realm.service';
import { Location } from '@angular/common';
import {ApiService} from '../Services/Api/api.service';
import {ICardDetails} from 'ng-payment-card/lib/domain/i-card-details';
import {environment} from '../../environments/environment';
import {SessionService} from '../Services/Session/session-service.service';
import {MessageService} from 'primeng';
@Component({
  selector: 'app-provider-others',
  templateUrl: './provider-others.component.html',
  styleUrls: ['./provider-others.component.css']
})
export class ProviderOthersComponent implements OnInit {
  type = '';
  typeSelectedProvider = '';
  parent = '';
  providers = [];
  resultProviders = [];
  globalFistProviders:any =[]
  filterResults: any =[];
  specialtiesResult: any =[];
  subSpecialtiesResult: any =[];
  providersCpy: any[] = [];
  specialties = {specialty:[],subSpecialty:[]}; 
  totalRecords!: number;
  cant = 1;
  selectedProvider: any;
  displayDialog: boolean;
  showDetailLocation: boolean;
  loading = true;
  infoProviders = [];
  showProviders = true;
  displayDialogUbication: boolean;
  ct: string;
  tp: string;
  dp: string;
  tn: string;
  sp: string;
  nm: string;
  tm = false;
  quequeVariable: string;
  quequePosition: number;
  quequeTime: string;
  isWaiting = false;
  copayment = false;
  copaymentInfo = [];
  isOnline: string;
  displayWaitDialog: boolean;
  selectedIdProvider: string;
  showWaiting: boolean;
  dialogCreditCard: boolean;
  paymentSuccess: boolean;
  validatecCNum: boolean;
  validatecCDate: boolean;
  doctorFilters: boolean =  false;
  env = environment;
  currentScreen = 1;
  isProviders = 1;
  isLocations: 2;
  currPosition: any = {lat: 0.0, lng: 0.0};
  isWait: 3;
  title: string;
  schedules = false;
  dataProviders: any;
  contactOrms: any;
  scheduleOrms: any;
  ipSearch = "";
  ipSearch1: any=null;
  ipSearch0: any=null;
  subSpecialtyEnabled!: boolean;
  specialtyEnabled!: boolean;
  selectedDepartment:any;
  applyDistance = false;
  ipdistance: any = 30;
  constructor(private activatedRoute: ActivatedRoute, private realm: RealmService,
              private router: Router, private location: Location, private cdRef: ChangeDetectorRef,
              private apiService: ApiService, private session: SessionService, private mservice: MessageService) {
  }

  ngOnInit(): void {
    this.env.showSteps = false;
    this.env.isContentLoading = true;
    this.activatedRoute.paramMap.subscribe(params => {
      this.type = params.get('type');
      this.parent = params.get('parent');
      if (params.has('ct') && params.has('tp') && params.has('tn') &&
        params.has('sp') && params.has('nm') && params.has('dp') && params.has('tm')) {
        this.ct = params.get('ct');
        this.tp = params.get('tp');
        this.dp = params.get('dp');
        this.tn = params.get('tn');
        this.sp = params.get('sp');
        this.nm = params.get('nm');
        this.tm = params.get('tm') !== 'false';
      }
    });
    this.realm.getPosition().then( res => {
      this.currPosition = res;
    });
    console.log(this.type);
    if (this.type == '1') {
      this.doctorFilters = true;
    }
    let typeProvider :any[] = [];
    if (this.type == '3') {
      typeProvider = ['3','6','7','9'];
    } else if (this.type === 'resultados') {
      typeProvider.push(this.tp);
    } else if (this.type === 'CAMPI') {
      typeProvider = ['7','9'];
    } else {
      typeProvider.push(this.type);
    }
    if (this.type === 'resultados') {
      this.env.isContentLoading = true;
      this.realm.getProvidersByType(this.ct, typeProvider, this.tm, this.dp, this.tn, this.sp, this.nm).then( data => {
      });
    } else if ( this.type === 'CAMPI' ) {
      this.env.isContentLoading = true;
      this.realm.getProvidersByType('502', typeProvider, true).then();
    } else {
      this.env.isContentLoading = true;
      this.realm.getProvidersByType('502', typeProvider).then();
    }
    this.realm.providersByTypeQuery$.subscribe( (d: any) => {
      if (d !== undefined) {
        this.providers = d.locationOrms;
        this.providersCpy = d.locationOrms;
        this.dataProviders = d;
        this.env.isContentLoading = false;
        this.loading = false;
        this.realm.updateScreenProviders(this.isProviders);
        this.currentScreen = this.isProviders;
        /*this.parseResult(d).then( (ds: any) => {

        });*/
      }
      // console.log(data);
    });
  }

  ngAfterViewInit():void{
    this.specialties = {specialty:[],subSpecialty:[]};
    this.realm.getSpecialtyList().then((data: any) => {
      this.specialties.specialty = data;
      //this.specialtiesResult = specialtiesOrder.filter(c => c.strDescription.toUpperCase().includes(field.toUpperCase()));
    });
    this.realm.getSubSpecialtyList().then((data: any) => {
      this.specialties.subSpecialty = data;
      //this.specialtiesResult = specialtiesOrder.filter(c => c.strDescription.toUpperCase().includes(field.toUpperCase()));
    });
  }
  
  parseResult(data: any) {
    // @ts-ignore
    // tslint:disable-next-line:forin
    const provq = [];
    return new Promise((resolve, reject) => {
      for (const dataKey in data) {
        let offlinetxt = '';
        if (data[dataKey][0].idProvider.offline) {
          offlinetxt = 'Online';
        } else { offlinetxt = 'Offline'; }
        provq.push({name: data[dataKey][0].idProvider.name, idProvider: data[dataKey][0].idProvider.idProvider, data: data[dataKey],
          telemedicine: data[dataKey][0].idProvider.telemedicine,
          priority: data[dataKey][0].idProvider.priority,
          offline: offlinetxt,
          queque: data[dataKey][0].idProvider.queque});
      }
      resolve(provq);
    });
  }
  async selectProvider(event: Event, provider: any) {
    console.log('selectProvider', provider);
    this.realm.getProviderInfo(provider);
    this.env.isContentLoading = true;
    this.realm.providersInfo$.subscribe((res: any) => {
      this.contactOrms = res.contactOrms;
      this.scheduleOrms = res.scheduleOrms;
      if (this.contactOrms !== null || this.scheduleOrms !== null) {
        this.schedules = true;
        this.env.isContentLoading = false;
      } else {
        this.env.isContentLoading = false;
        this.mservice.clear();
        this.mservice.add({severity: 'warn', summary: 'Aviso', detail: 'Lo sentimos no hay informacion de este proveedor.', sticky: false});
      }
    });
  }
  telemedicine(provider: any) {
    // this.isWaiting = true;
    // this.showDetailLocation = false;
    // this.displayDialogUbication = false;
    // this.realm.getWaitList()
    // this.cpayment(true, provider);
    this.waitList(true, provider);
    this.title = 'Proceso de Pago';
    // this.router.navigate(['/telemedicine']);
  }
  waitList(wait: boolean, provider: any) {
    // this.displayWaitDialog = wait;
    // this.isWaiting = wait;
    this.selectedProvider = provider;
    this.env.selectedProvider = provider;
    this.currentScreen = this.isWait;
    this.title = 'Proceso de Pago';
    this.session.saveParam('showSteps', 'true');
    this.session.saveParam('selectedProvider', JSON.stringify(provider));
    this.router.navigate(['home/checkout']);
  }
  cpayment(copa: boolean, provider: any) {
    // this.env.isContentLoading = true;
    console.log('copayment', provider);
    this.copaymentInfo = [];
    this.typeSelectedProvider = provider.code;
    console.log('PROVIDEROTHER', this.typeSelectedProvider);
    if (copa) {
      this.env.isContentLoading = true;
      this.realm.getCopaymentbyProvider(this.typeSelectedProvider);
      this.apiService.responseGet$.subscribe( data => {
        const qw: any = data;
        console.log(qw);
        this.env.isContentLoading = false;
        if (qw.code === 701) {
          this.copaymentInfo = qw.resultInsuredPartipation.success;
          console.log(this.copaymentInfo);
          this.copayment = copa;
          this.displayWaitDialog = false;
          this.displayDialogUbication = false;
        }
      });
    } else {
      this.copayment = copa;
      this.displayDialogUbication = true;
    }
  }
  cCard(ccard: boolean) {
    this.dialogCreditCard = ccard;
    this.copayment = false;
  }

  processPayment($event: ICardDetails) {
    // todo si el pago fue procesado exitosamente llamar el api para agregar una persona a la cola. y mostrar dialogo de posicion actual.
    // todo llamar api para verificar si pago fue realizado y si la llamada fue realizada y finalizada con exito. de lo contrario omitir pago y proceder a espera.
    console.log($event);
    /*cardHolder: "asdfasfasdfa"
​
    cardNumber: "377720745104636"
    ​
    ccv: "123"
    ​
    expirationMonth: "11"
    ​
    expirationYear: "2024"*/
    const statusPayment = true;
    const statusCall = false;
    this.showWaiting = true;
    this.dialogCreditCard = false;
    this.paymentSuccess = statusPayment && !statusCall;
    if (this.isWaiting && this.paymentSuccess) {
      this.router.navigate(['home/telemedicine', this.selectedIdProvider, this.typeSelectedProvider]);
    }
  }
  exitWait() {
    this.displayWaitDialog = false;
    this.isWaiting = false;
    this.displayDialogUbication = false;
    // todo llamar el api para remover una persona de la cola unicamente si ya se realizo el pago y no se ha echo la llamada.
  }
  back() {
    // this.router.navigate(['..']);
    this.isWaiting = false;
    this.copayment = false;
    this.realm.currentScreen$.subscribe( (value: number) => {
      if (this.currentScreen !== value) {
        this.currentScreen = value;
        console.log('CURRENTSCREEN', this.currentScreen);
      }
    });
    switch (this.currentScreen) {
      case this.isLocations: {
        this.realm.updateScreenProviders(this.isProviders);
        break;
      }
      case this.isWait: {
        this.realm.updateScreenProviders(this.isLocations);
        break;
      }
      case this.isProviders: {
        this.location.back();
        break;
      }
      default: {
        this.realm.updateScreenProviders(this.isProviders);
        break;
      }
    }
  }

  calcDist(provider: any) {
    // tslint:disable-next-line:max-line-length
    return this.realm.calculationByDistance(JSON.parse(this.currPosition.lat), provider.latitude, this.currPosition.lng, provider.longitude);
  }

  selectSpecialty() {
    if (this.ipSearch0 != null) {
      this.specialtyEnabled = true;
      if (this.ipSearch0.length == 0) {
        this.specialtyEnabled = false;
      }
    } else {
      this.specialtyEnabled = false;
    }
  }

  selectSubSpecialty() {
    if (this.ipSearch1 != null) {
      this.subSpecialtyEnabled = true;
      if (this.ipSearch1.length == 0) {
        this.subSpecialtyEnabled = false;
      }
    } else {
      this.subSpecialtyEnabled = false;
    }
  }

  searchSpecialty(event:any): void {
    let field: string = event.query;
    let specialtiesOrder:any[] = this.specialties.specialty;
    this.specialtiesResult = specialtiesOrder.filter(c => c.strDescription.toUpperCase().includes(field.toUpperCase()));    
  }

  searchSubSpecialty(event:any): void {
    let field: string = event.query;
    let subSpecialtiesOrder:any[] = this.specialties.subSpecialty;
    this.subSpecialtiesResult = subSpecialtiesOrder.filter(c => c.strDescription.toUpperCase().includes(field.toUpperCase()));
    console.log("size subspecialtiesresult: "+ this.subSpecialtiesResult.length);
  }

  regexFilter(search:string) {
    let arrSearch = search.toUpperCase().split(' ');
    let arrRex:any [] = [];
    let resArray:any [] = [];
    arrSearch.map((element:any) => {
      arrRex.push('(?=.*'+element+')')
    });
    let joined = arrRex.join("");
    let regex = new RegExp("^"+joined+".*\$");
    console.log("joined: ", joined);
    console.log("buscar: ", search);
    let completeArray:any[] = this.providersCpy;
    
    completeArray.map((provider:any, index: number) => {
      //console.log();
      if (regex.test(provider.idProvider.name)) {
        resArray.push(provider);
      }
    });
    console.log("size: ", resArray.length);
    this.providers = resArray;
  }

  /*
  async search(b: boolean) {
    this.filterResults = [];
    if (!b) {
      this.globalFistProviders = this.providers;

      // NO EXISTE FILTRO, APLICAR LISTADO GLOBAL
      if ((this.ipSearch0 === null || this.ipSearch0 == "")  && (this.ipSearch1 === null || this.ipSearch1 == "") && !this.applyDistance) {
        this.globalFistProviders = this.providers;
        this.providers = this.providers;
      }

      if ((this.selectedDepartment != null )) {
        console.log("entra");
        console.log(this.selectedDepartment.strDescription);
        this.globalFistProviders.map((provider:any)=>{
          console.log(provider.fullAddress);
          if(provider.fullAddress.toUpperCase().indexOf(this.selectedDepartment.strDescription.toUpperCase()) !== -1){
            console.log("MATCH");
            this.filterResults.push(provider);
          }
        })
        //this.filterResults = filterLocations;
        this.globalFistProviders = this.filterResults;
        this.providers = this.globalFistProviders;
      }

      if (this.applyDistance) {
        let filterLocations:any = [];
        this.providers.map((provider:any)=>{
          if(provider.distance != undefined && provider.distance>=0){
            if(provider.distance <= this.ipdistance){
              filterLocations.push(provider);
            }
          }
        })
        //this.filterResults = filterLocations;
        this.globalFistProviders = filterLocations;
      } else {
        this.filterResults = [];
        this.globalFistProviders = this.providers;
      }

      //let filterSpecialties:any = [];
      // BUSCAR POR ESPECIALIDAD
      if(this.ipSearch0 !== null && this.ipSearch0 != "") {
        if(this.ipSearch0.strDescription === undefined ) {
          this.ipSearch0 = this.specialtiesResult[0];
        }
        this.globalFistProviders.map((provider:any) => {
          if ( provider.idProvider.specialty != undefined ) {
            provider.idProvider.specialty.map((specialty:any) => {
              if (specialty.strDescription == this.ipSearch0.strDescription) {
                // SE CUMPLE ESPECIALIDAD, VALIDAR SI CUMPLE SUBESPECIALIDAD
                if(this.ipSearch1 !== null && this.ipSearch1 != "") {
                  if ( provider.idProvider.SubSpecialty != undefined ) {
                    provider.idProvider.SubSpecialty.map((subSpecialty:any) => {
                      if (subSpecialty.strDescription == this.ipSearch1.strDescription) {
                        // PROVEEDOR CUMPLE ESPECIALIDAD Y SUB ESPECIALIDAD, AGREGAR PROVEEDOR
                        this.filterResults.push(provider);
                      }
                    })
                  }
                } else {
                  // NO SE BUSCA SUBESPECIALIDAD, AGREGAR PROVEEDOR
                  this.filterResults.push(provider);
                }
              }
            })
          }
        });
        // RESULTADO ESPECIALIDAD Y SUBESPECIALIDAD
        this.providers = this.filterResults;
      } else {
        //NO SE BUSCA ESPECIALIDAD, VALIDAR SI SE BUSCA SUB ESPECIALIDAD
        if(this.ipSearch1 !== null && this.ipSearch1 != "") {
          if(this.ipSearch1.strDescription === undefined ) {
            this.ipSearch1 = this.subSpecialtiesResult[0];
          }
          this.globalFistProviders.map((provider:any) => {
            if ( provider.idProvider.SubSpecialty != undefined ) {
              provider.idProvider.SubSpecialty.map((subSpecialty:any) => {
                if (subSpecialty.strDescription == this.ipSearch1.strDescription) {
                  // PROVEEDOR CUMPLE CON SUB ESPECIALIDAD, AGREGAR PROVEEDOR
                  this.filterResults.push(provider);
                }
              })
            }
          });
          // RESULTADO SUBESPECIALIDADES
          this.providers = this.filterResults;
        } else {
          // NO SE BUSA ESPECIALIDAD, NO SE BUSCA SUB ESPECIALIDAD
          if (this.applyDistance) {
            this.providers = this.globalFistProviders;
          }
        }
      } 
      this.totalRecords = this.providers.length;
    } else {
      this.filterResults = [];
      this.providers =  this.globalFistProviders;
    }
  }*/
}
